import { useEffect } from "react";

const ChatbaseWidget = () => {
  useEffect(() => {
    // Évite d'insérer le script plusieurs fois
    if (document.getElementById("chatbase-script")) return;

    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      (function(){
        if(!window.chatbase || window.chatbase("getState") !== "initialized") {
          window.chatbase = (...arguments) => {
            if (!window.chatbase.q) {
              window.chatbase.q = [];
            }
            window.chatbase.q.push(arguments);
          };
          window.chatbase = new Proxy(window.chatbase, {
            get(target, prop) {
              if (prop === "q") {
                return target.q;
              }
              return (...args) => target(prop, ...args);
            }
          });
        }

        const onLoad = function() {
          const script = document.createElement("script");
          script.src = "https://www.chatbase.co/embed.min.js";
          script.id = "PjSdv8JBUY8PJ3I9j-zTh";
          script.domain = "www.chatbase.co";
          document.body.appendChild(script);
        };

        if (document.readyState === "complete") {
          onLoad();
        } else {
          window.addEventListener("load", onLoad);
        }
      })();
    `;
    inlineScript.id = "chatbase-script";
    document.body.appendChild(inlineScript);
  }, []);

  return null; // Pas besoin d'afficher quoi que ce soit
};

export default ChatbaseWidget;